import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// スライド間隔 (Figma: SP 12px / PC 20px)
const SPACE_SP = 12;
const SPACE_PC = 20;
const BREAKPOINT_PC = 769;

const blockCampaign = () => {
    document.querySelectorAll('.js-campaign-swiper').forEach((el) => {
        if (el.dataset.initialized === 'true') return;

        const wrapper = el.querySelector('.swiper-wrapper');
        const originalSlides = Array.from(el.querySelectorAll('.swiper-slide'));
        const originalCount = originalSlides.length;
        if (!wrapper || originalCount === 0) return;

        el.dataset.initialized = 'true';

        // ループ時に端のスライドが途切れないよう、常に十分な枚数を確保する
        // (centeredSlides + slidesPerView: 'auto' では画面内に約3枚見えるため余裕を持たせる)
        const MIN_SLIDES = 8;
        if (originalCount < MIN_SLIDES) {
            const times = Math.ceil(MIN_SLIDES / originalCount);
            for (let i = 1; i < times; i++) {
                originalSlides.forEach(slide => {
                    wrapper.appendChild(slide.cloneNode(true));
                });
            }
        }

        const paginationEl = el
            .closest('.c-others-block-campaign')
            ?.querySelector('.js-campaign-pagination');

        const swiper = new Swiper(el, {
            modules: [Autoplay],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: SPACE_SP,
            breakpoints: {
                [BREAKPOINT_PC]: {
                    spaceBetween: SPACE_PC,
                },
            },
            centeredSlides: true,
            loopAdditionalSlides: 2,
            slideToClickedSlide: true,
            watchOverflow: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });

        if (!paginationEl) return;

        paginationEl.innerHTML = '';

        // ページネーションはオリジナル件数だけ並べる
        const bullets = [];
        for (let i = 0; i < originalCount; i++) {
            const bullet = document.createElement('span');
            bullet.className = 'swiper-pagination-bullet';
            bullet.dataset.index = String(i);
            paginationEl.appendChild(bullet);
            bullets.push(bullet);
        }

        const updateActiveBullet = () => {
            const activeIdx = swiper.realIndex % originalCount;
            bullets.forEach((b, i) => {
                b.classList.toggle('swiper-pagination-bullet-active', i === activeIdx);
            });
        };

        swiper.on('slideChange', updateActiveBullet);
        updateActiveBullet();

        paginationEl.addEventListener('click', event => {
            const bullet = event.target.closest('.swiper-pagination-bullet');
            if (!bullet) return;
            const index = Number.parseInt(bullet.dataset.index ?? '', 10);
            if (Number.isNaN(index)) return;
            swiper.slideToLoop(index);
        });
    });
};

export default blockCampaign;
